import axios from "axios";
import { useEffect, useState } from "react";
import dfltimg from '../images/loader.gif';
import { useNavigate } from "react-router";
const Dashboard=()=>
{
    const [p1,setP1]=useState(dfltimg);
    const [p2,setP2]=useState(dfltimg);
    const [p3,setP3]=useState(dfltimg);
    const [p4,setP4]=useState(dfltimg);
    const [p5,setP5]=useState(dfltimg);
    const [p6,setP6]=useState(dfltimg);
    let nav=useNavigate();
    const loadImage1=async ()=>
    {
        const token = localStorage.getItem("token");                
        axios.get(process.env.REACT_APP_APIURL+"/api/DashBoardImage/Chart1", {
            responseType: "blob",    // IMPORTANT for image
            headers: {
            Authorization: `Bearer ${token}`  // send token here
            }
        }).then((res) =>
        {
            const url = URL.createObjectURL(res.data);
            setP1(url);
        }).catch((err) => {
            //console.error("Image loading error", err);
        });
        // Cleanup blob URL
        return () =>
        {
            if (p1) URL.revokeObjectURL(p1);
        };        
    };
    const loadImage2=async ()=>
    {
        const token = localStorage.getItem("token");                
        axios.get(process.env.REACT_APP_APIURL+"/api/DashBoardImage/Chart2", {
            responseType: "blob",    // IMPORTANT for image
            headers: {
            Authorization: `Bearer ${token}`  // send token here
            }
        }).then((res) =>
        {
            const url = URL.createObjectURL(res.data);
            setP2(url);
        }).catch((err) => {
            //console.error("Image loading error", err);
        });
        // Cleanup blob URL
        return () =>
        {
            if (p2) URL.revokeObjectURL(p2);
        };        
    };
    const loadImage3=async ()=>
    {
        const token = localStorage.getItem("token");                
        axios.get(process.env.REACT_APP_APIURL+"/api/DashBoardImage/Chart3", {
            responseType: "blob",    // IMPORTANT for image
            headers: {
            Authorization: `Bearer ${token}`  // send token here
            }
        }).then((res) =>
        {
            const url = URL.createObjectURL(res.data);
            setP3(url);
        }).catch((err) => {
            //console.error("Image loading error", err);
        });
        // Cleanup blob URL
        return () =>
        {
            if (p3) URL.revokeObjectURL(p3);
        };        
    };
    const loadImage4=async ()=>
    {
        const token = localStorage.getItem("token");                
        axios.get(process.env.REACT_APP_APIURL+"/api/DashBoardImage/Chart4", {
            responseType: "blob",    // IMPORTANT for image
            headers: {
            Authorization: `Bearer ${token}`  // send token here
            }
        }).then((res) =>
        {
            const url = URL.createObjectURL(res.data);
            setP4(url);
        }).catch((err) => {
            //console.error("Image loading error", err);
        });
        // Cleanup blob URL
        return () =>
        {
            if (p4) URL.revokeObjectURL(p4);
        };        
    };
    const loadImage5=async ()=>
    {
        const token = localStorage.getItem("token");                
        axios.get(process.env.REACT_APP_APIURL+"/api/DashBoardImage/Chart5", {
            responseType: "blob",    // IMPORTANT for image
            headers: {
            Authorization: `Bearer ${token}`  // send token here
            }
        }).then((res) =>
        {
            const url = URL.createObjectURL(res.data);
            setP5(url);
        }).catch((err) => {
            //console.error("Image loading error", err);
        });
        // Cleanup blob URL
        return () =>
        {
            if (p5) URL.revokeObjectURL(p5);
        };        
    };
    const loadImage6=async ()=>
    {
        const token = localStorage.getItem("token");                
        axios.get(process.env.REACT_APP_APIURL+"/api/DashBoardImage/Chart6", {
            responseType: "blob",    // IMPORTANT for image
            headers: {
            Authorization: `Bearer ${token}`  // send token here
            }
        }).then((res) =>
        {
            const url = URL.createObjectURL(res.data);
            setP6(url);
        }).catch((err) => {
            //console.error("Image loading error", err);
        });
        // Cleanup blob URL
        return () =>
        {
            if (p6) URL.revokeObjectURL(p6);
        };        
    };
    useEffect(()=>{
        if(localStorage.getItem("token")=="")
        {
            nav("/");
        }   
        else
        {
            loadImage1();
            loadImage2();
            loadImage3();
            loadImage4();
            loadImage5();
            loadImage6();
        }
    },[]);
    return(        
        <div className="row">            
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-12 p-3">
                <div className="border shadow p-2 rounded text-center">
                    <img src={p1} alt="" className="w-75" />
                </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-12 p-3">
                <div className="border shadow p-2 rounded text-center">
                    <img src={p2} alt="" className="w-75"  />
                </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-12 p-3">
                <div className="border shadow p-2 rounded text-center">
                    <img src={p3} alt="" className="w-75"  />
                </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-12 p-3">
                <div className="border shadow p-2 rounded text-center">
                    <img src={p4} alt="" className="w-75"  />
                </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-12 p-3">
                <div className="border shadow p-2 rounded text-center">
                    <img src={p5} alt="" className="w-75"  />
                </div>
            </div>
            <div className="col-12 p-3">
                <div className="border shadow p-2 rounded text-center">
                    <img src={p6} alt="" className="w-75"  />
                </div>
            </div>
        </div>                
    );
}
export default Dashboard;